import { createAction } from 'redux-actions';

export const loadableStart = createAction('LOADABLE_START');
export const loadableFinish = createAction('LOADABLE_FINISH');
